import React, { FC, useState } from "react";
import Image from "next/image";
import classNames from "classnames";

import styles from "./FeatureCard.module.css";
import { AddPlus } from "ui-kit/icons";

type FeatureCardImage = {
  url?: string | null;
  description?: string | null;
  width?: number | null;
  height?: number | null;
} | null;

type FeatureCardProps = {
  title: string | null;
  description: string | null;
  text: string | null;
  color: string | null;
  image: FeatureCardImage;
  variant?: "grid" | "carousel";
};

const FeatureCard: FC<FeatureCardProps> = ({
  title,
  description,
  text,
  color,
  image,
  variant = "grid",
}) => {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <div
      className={classNames(
        styles.cardWrapper,
        variant === "carousel" && styles.cardWrapperCarousel,
        isFlipped && styles.flipped,
        color && styles[color]
      )}
    >
      <div className={styles.front}>
        <div>
          <h3 className={styles.frontTitle}>{title}</h3>
          {description && (
            <p className={styles.frontDescription}>{description}</p>
          )}
        </div>
        {image?.url && (
          <div className={styles.frontImageContainer}>
            <Image
              src={image.url}
              alt={image.description ?? ""}
              width={image.width ?? 300}
              height={image.height ?? 300}
              sizes="200px"
              className={styles.frontImage}
            />
          </div>
        )}
      </div>
      {text && (
        <div className={styles.back}>
          <h3 className={styles.backTitle}>{title}</h3>
          <span className={styles.backText}>{text}</span>
        </div>
      )}
      {text && (
        <button
          className={styles.flipButton}
          onClick={() => setIsFlipped((flipped) => !flipped)}
          aria-label={isFlipped ? "Close" : "Read more"}
        >
          <AddPlus size={16} color="currentColor" />
        </button>
      )}
    </div>
  );
};

export default FeatureCard;
